import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { ActionItems } from 'src/app/models/actionItems';
import { FormBuilder, FormGroup, FormControl, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { MatDialog } from '@angular/material/dialog';
import { ModalsService } from 'src/app/modals/modals.service';
import { MatTooltipModule } from '@angular/material/tooltip';


@Component({
  selector: 'app-add-action-item',
  templateUrl: './add-action-item.component.html',
  styleUrls: ['./add-action-item.component.scss']
})
export class AddActionItemComponent implements OnInit {

  public actionItemForm!: FormGroup;

  constructor(
    private fb: FormBuilder,
    private router: Router,
   // public fireGoalsAssessment: ActionItemsService,
    public matDialog: MatDialog,
    public modal: ModalsService
  ) { }

  
  ngOnInit(): void {
 /*   this.actionItemForm.fb.group({
      actionItemName: [null, Validators.required],
      actionItemNotes: [null, Validators.required],
      actionItemDueDate: [null, Validators.required]
    })*/
  }

  ResetForm() {
    this.actionItemForm.reset();
  }

  onSubmit() {
   // this.actionItemForm.createSustainibleGoals({...this.actionItemForm.value});
    this.ResetForm();
    this.router.navigate(['goals']);
  }
}
